import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { NavLink } from 'react-router-dom';
import daySkipped from '../../utils/daySkipped';
import './Nav.css';

const returnFalse = () => true; // (e.preventDefault(), false);

const stepIdx = {
  '/': 0,
  '/package': 1,
  '/addons': 2,
  '/guest-info': 3,
  '/review': 4,
  '/checkout': 5
};

const Nav = ({ sale, config, location }) => (
  <div className="flex flex-row">
    {!sale.done && (
      <div className="justify-between step-progress pa3">
        {daySkipped(config) !== true && (
          <>
            <NavLink
              onClick={returnFalse}
              exact
              className={classNames({
                ['step']: true,
                ['step-complete']: stepIdx[location.pathname] > stepIdx['/']
              })}
              activeClassName="step-active"
              to="/"
              title="Day"
            />
            <span
              className={classNames({
                ['step-line']: true,
                ['step-line-complete']:
                  stepIdx[location.pathname] > stepIdx['/']
              })}
            />
          </>
        )}
        <NavLink
          onClick={returnFalse}
          className={classNames({
            ['step']: true,
            ['step-complete']: stepIdx[location.pathname] > stepIdx['/package']
          })}
          activeClassName="step-active"
          to="/package"
          title="Package"
        />
        <span
          className={classNames({
            ['step-line']: true,
            ['step-line-complete']:
              stepIdx[location.pathname] > stepIdx['/package']
          })}
        />
        <NavLink
          onClick={returnFalse}
          className={classNames({
            ['step']: true,
            ['step-complete']: stepIdx[location.pathname] > stepIdx['/addons']
          })}
          activeClassName="step-active"
          to="/addons"
          title="Add-Ons"
        />
        <span
          className={classNames({
            ['step-line']: true,
            ['step-line-complete']:
              stepIdx[location.pathname] > stepIdx['/addons']
          })}
        />
        {config.guestMods && (
          <>
            <NavLink
              onClick={returnFalse}
              className={classNames({
                ['step']: true,
                ['step-complete']:
                  stepIdx[location.pathname] > stepIdx['/guest-info']
              })}
              activeClassName="step-active"
              to="/guest-info"
              title="Guest Info"
            />
            <span
              className={classNames({
                ['step-line']: true,
                ['step-line-complete']:
                  stepIdx[location.pathname] > stepIdx['/guest-info']
              })}
            />
          </>
        )}
        <NavLink
          onClick={returnFalse}
          className={classNames({
            ['step']: true,
            ['step-complete']: stepIdx[location.pathname] > stepIdx['/review']
          })}
          activeClassName="step-active"
          to="/review"
          title="Review"
        />
        <span
          className={classNames({
            ['step-line']: true,
            ['step-line-complete']:
              stepIdx[location.pathname] > stepIdx['/review']
          })}
        />
        <NavLink
          onClick={returnFalse}
          className={classNames({
            ['step']: true,
            ['step-complete']: false
          })}
          activeClassName="step-active"
          to="/checkout"
          title="Checkout"
        />
      </div>
    )}
  </div>
);

Nav.propTypes = {
  children: PropTypes.any,
  sale: PropTypes.object,
  config: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  sale: state.sale,
  config: state.config
});

export default connect(mapStateToProps)(withRouter(Nav));
